<template>
  <div>
    <v-card class="no-shadow">
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center"
          ><v-icon>mdi-file-document-multiple-outline</v-icon> Formularios
          Dinámicos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          elevation="2"
          @click="goCrear"
          class="btn-principal"
          v-if="user.access.formWrite"
        >
          <v-icon>mdi-plus</v-icon>
          Crear Formulario
        </v-btn>
      </v-toolbar>

      <v-card flat>
        <v-expansion-panels>
          <v-expansion-panel v-if="preguntas.length > 0">
            <v-expansion-panel-header>
              <span class="titulo-form">{{ nombreFormulario }}</span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn small fab class="mr-4" elevation="2">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn small fab class="mr-4" elevation="2">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" v-for="(item, index) in preguntas" :key="index">
                <v-row>
                  <v-col cols="12" class="text-pregunta">
                    {{ item.text }}
                  </v-col>

                  


                  <v-col
                    cols="12"
                    class="respuestas"
                    v-if="item.respuestas.length > 0"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        class="mt-0 pt-0 mb-0 pb-0"
                        v-for="(item2, j) in item.respuestas"
                        :key="j"
                      >
                        <v-row>
                          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-row>
                              <v-col
                                cols="12"
                                class="mt-0 pt-0 mb-0 pb-0"
                                v-if="item.tipo == 0"
                              >
                                <v-checkbox
                                  :label="`${item2.text}`"
                                  class="mt-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col
                                cols="12"
                                v-if="item.tipo == 1"
                                class="mt-0 pt-0 mb-0 pb-0"
                              >
                                <v-radio-group>
                                  <v-radio
                                    :key="index"
                                    :label="`${item2.text}`"
                                    :value="index"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-0 pt-0 mb-0 pb-0"
                                v-if="item.tipo == 2"
                              >
                                <v-radio-group>
                                  <v-radio
                                    :key="index"
                                    :label="`${item2.text}`"
                                    :value="index"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
<v-col cols="12" v-if="item.tipo == 3">
                    <v-text-field
                      v-model="formRespuesta.text"
                      label="Ingresa tu respuesta"
                    ></v-text-field>
                  </v-col>


                   <v-col cols="12" v-if="item.tipo == 5">
               
                  
                <div cols="12 mt-2" >
                 <v-btn class="mt-3" dark color="gray" @click="mostrarFirma(item)">
                    <v-icon>plus-thick</v-icon>
                    Firmar </v-btn>
                </div>
              
                </v-col>

                   <v-col cols="12" v-if="item.tipo == 4">
                <input type="file" @change="previewFiles" multiple>

                </v-col>
            
                </v-row>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- dos -->

          <v-expansion-panel v-if="preguntas.length > 0">
            <v-expansion-panel-header>
              <span class="titulo-form">{{ nombreFormulario }}</span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn small fab class="mr-4" elevation="2">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn small fab class="mr-4" elevation="2">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" v-for="(item, index) in preguntas" :key="index">
                <v-row>
                  <v-col cols="12" class="text-pregunta">
                    {{ item.text }}
                  </v-col>

                  


                  <v-col
                    cols="12"
                    class="respuestas"
                    v-if="item.respuestas.length > 0"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        class="mt-0 pt-0 mb-0 pb-0"
                        v-for="(item2, j) in item.respuestas"
                        :key="j"
                      >
                        <v-row>
                          <v-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
                            <v-row>
                              <v-col
                                cols="12"
                                class="mt-0 pt-0 mb-0 pb-0"
                                v-if="item.tipo == 0"
                              >
                                <v-checkbox
                                  :label="`${item2.text}`"
                                  class="mt-0"
                                ></v-checkbox>
                              </v-col>
                              <v-col
                                cols="12"
                                v-if="item.tipo == 1"
                                class="mt-0 pt-0 mb-0 pb-0"
                              >
                                <v-radio-group>
                                  <v-radio
                                    :key="index"
                                    :label="`${item2.text}`"
                                    :value="index"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-0 pt-0 mb-0 pb-0"
                                v-if="item.tipo == 2"
                              >
                                <v-radio-group>
                                  <v-radio
                                    :key="index"
                                    :label="`${item2.text}`"
                                    :value="index"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
<v-col cols="12" v-if="item.tipo == 3">
                    <v-text-field
                      v-model="formRespuesta.text"
                      label="Ingresa tu respuesta"
                    ></v-text-field>
                  </v-col>


                   <v-col cols="12" v-if="item.tipo == 5">
               
                  
                <div cols="12 mt-2" >
                 <v-btn class="mt-3" dark color="gray" @click="mostrarFirma(item)">
                    <v-icon>plus-thick</v-icon>
                    Firmar </v-btn>
                </div>
              
                </v-col>

                   <v-col cols="12" v-if="item.tipo == 4">
                <input type="file" @change="previewFiles" multiple>

                </v-col>
            
                </v-row>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-card>
     <v-dialog v-model="firmar" width="900px">
      <firma :rowPregunta="rowPreguntaFirma"  v-on:firma="recibeFirma" />
   </v-dialog>
  </div>

  
</template>
<script>
import axios from "axios";
import api from "../../conf/ruta-base";
import store from "../../store";
import router from "../../router";
import UserProfile from "../../data";
import XLSX from "xlsx";
import vueSignature from "vue-signature";
import Firma from "../formulario-dinamico/firma.vue"
export default {
  name: "Formulario",
  components: {
    vueSignature,
    Firma
  },
  data() {
    return {
      rowPreguntaFirma: "",
      firmar: false,
      user: UserProfile.getUserData(),
      option: {
        penColor: "rgb(0,0,0)",
        backgroundColor: "rgb(255,255,255)",
      },
      cargarPreguntas: false,
      cargarRespuesta: false,
      obtenerIndexPregunta: 0,
      formPreguntas: {
        text: "",
        index: 0,
        tipo: "",
        respuestas: [],
      },
      formRespuesta: {
        text: "",
      },
      tipoPregunta: [
        { text: "Respuesta múltiple", value: "0" },
        { text: "Verdadero o Falso", value: "1" },
        { text: "Respuesta única", value: "2" },
        { text: "Respuesta libre", value: "3" },
      ],
      nombreFormulario: "Formulario de prueba ",
      preguntas: [
        {
          text: "Pregunta de tipo Respuesta múltiple",
          tipo: "0",
          respuestas: [
            {
              text: "Respuesta 1",
            },
            {
              text: "Respuesta 2",
            },
            {
              text: "Respuesta 3",
            },
            {
              text: "Respuesta 4",
            },
          ],
        },
        {
          text: "Pregunta de tipo Verdadero o Falso",
          tipo: "1",
          respuestas: [
            {
              text: "Respuesta 1",
            },
            {
              text: "Respuesta 2",
            },
            {
              text: "Respuesta 3",
            },
            {
              text: "Respuesta 4",
            },
          ],
        },
        {
          text: "Pregunta de tipo Respuesta única",
          tipo: "2",
          respuestas: [
            {
              text: "Respuesta 1",
            },
            {
              text: "Respuesta 2",
            },
            {
              text: "Respuesta 3",
            },
            {
              text: "Respuesta 4",
            },
          ],
        },
        {
          text: "Pregunta de tipo Respuesta libre",
          tipo: "3",
          respuestas: [
            {
              text: "Respuesta 1",
            },
            {
              text: "Respuesta 2",
            },
            {
              text: "Respuesta 3",
            },
            {
              text: "Respuesta 4",
            },
          ],
        },
        {
          text: "Pregunta de tipo  Subir archivo",
          tipo: "4",
          respuestas: [
            {
              text: "Respuesta 1",
            },
            {
              text: "Respuesta 2",
            },
            {
              text: "Respuesta 3",
            },
            {
              text: "Respuesta 4",
            },
          ],
        },
        {
          text: "Pregunta de tipo Firma",
          tipo: "5",
          respuestas: [
            {
              firma : ""
            },
            
          ],
        },
      ],
      canvas: document.getElementsByClassName("canvas"),
      respuestas: [],
    };
  },
  created() {
    this.editedItem = Object.assign({}, this.defaultItem);
  },
  mounted() {
    this.fecinicio = this.date;
    this.fecfin = this.date;
  },
  methods: {
    recibeFirma(event) {
      this.rowPreguntaFirma = event;
      console.log('recibe firma', event);
    },
    mostrarFirma(event) {
      this.firmar = true;
      this.rowPreguntaFirma = event;
      console.log('manda firma', event);
    },
    goCrear() {
      router.push("crear-formulario");
    },
    savePregunta() {
      if (
        this.formPreguntas.text.length > 0 &&
        this.formPreguntas.tipo.length > 0
      ) {
        this.formPreguntas.index++;
        this.preguntas.push(this.formPreguntas);
        this.limpiar();
        this.toast("rojo", "pregunta Guardada");
        this.cargarPreguntas = false;
      } else {
        this.toast("rojo", "Campos vacios");
      }
    },
    saveRespuesta() {
      if (this.formRespuesta.text.length > 0) {
        this.preguntas[0].respuestas.push(this.formRespuesta);
        this.respuestas.push(this.formRespuesta);
        this.limpiar();
        this.toast("rojo", "respuesta Guardada");
        this.cargarRespuesta = false;
      } else {
        this.toast("rojo", "Campos vacios");
      }
    },
    indexPregunta() {
      // this.obtenerIndexPregunta = data;
      this.cargarRespuesta = true;
    },
    limpiar() {
      this.formPreguntas = {
        text: "",
        tipo: "",
      };
      this.formRespuesta = {
        text: "",
      };
    },
    //dayaana
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    exportExcel(datosXLS) {
      let data = XLSX.utils.json_to_sheet(datosXLS);
      const workbook = XLSX.utils.book_new();
      const filename = "reporte-fullclean";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    fechasave(evento) {
      if (evento == "inicio") {
        this.fecinicio = this.date;
      } else if (evento == "fin") {
        this.fecfin = this.date;
      }
      this.dialogofType = "";
      this.calendario = false;
      this.date = new Date().toISOString().substr(0, 10);
    },

    fechas(evento) {
      this.dialogofType = evento;
      this.calendario = true;
    },

    consultar() {
      this.datos = [];
      this.datosExcel = [];
      axios
        .get(api.api + this.apiPath + `/rango/${this.fecinicio}/${this.fecfin}`)
        .then((r) => {
          r.data.forEach((reg) => {
            let hora = reg.fecha
              .split("T")[1]
              .split(".")[0]
              .split(":");
            reg.hora = hora[0] + ":" + hora[1];
            reg.fecha = reg.fecha.split("T")[0];
            let excel = {
              Fecha: reg.fecha,
              Hora: reg.hora,
              Instalacion: reg.organizacion.nombre,
              Area: reg.area.nombre,
              Usuario: reg.user.nombre,
              Latitud: reg.lat,
              Longitud: reg.lng,
            };
            this.datosExcel.push(excel);
            this.datos.push(reg);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    previewFiles(event) {
      console.log(event.target.files);
    },
  },
};
</script>

<style scoped>
.margin {
  margin: 12px;
}
.margin-left {
  margin-left: 12px;
}
.v-input--selection-controls.v-input--radio-group {
  margin-top: 0 !important;
}
</style>
<style>
.v-expansion-panel--active > .v-expansion-panel-header {
  border-bottom: 1px solid #e2e2e2;
}
.v-expansion-panel > .v-expansion-panel-header {
  min-height: 64px;
}
.titulo-form {
  font-weight: bold;
  font-size: 1.1rem;
}
.text-pregunta {
  font-size: 1rem;
  font-weight: bold;
}
.respuestas .v-messages {
  display: none;
}
.v-dialog {
  background-color: #ffffff !important;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
.marginFirma {
  -webkit-box-shadow: -2px 2px 18px -1px #00000099;
  box-shadow: -2px 2px 18px -1px #00000054;
}
</style>
